document.addEventListener('DOMContentLoaded', function() {

  let catSlidersArr = document.querySelectorAll('.catalog-section-slider');

  

  if(catSlidersArr.length > 0 ){
    catSlidersArr.forEach(function(element){
      let slNav = element.closest('.tab-item').querySelector('.sl-nav');
      let slPag = element.closest('.tab-item').querySelector('.swiper-pagination');
      slider = new Swiper(element, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        navigation: {
            prevEl: slNav.querySelector('.sl-nav__btn--prev'),
            nextEl: slNav.querySelector('.sl-nav__btn--next'),
        },
        pagination: {
          el: slPag,
          clickable: true,
      },
      });
    })
  }

});